const baseConfig = {
  requestTimeout: 60000,
  ignoreSelfSignedCert: true,
}

const devConfig = {
  ...baseConfig,
  paymentMethodsPricingServiceUrl:
    process.env.REACT_APP_PAYMENT_METHODS_PRICING_SERVICE_URL,
  baseUrl: process.env.REACT_APP_BASE_URL,
}

const prodConfig = {
  ...baseConfig,
  paymentMethodsPricingServiceUrl:
    process.env.REACT_APP_PAYMENT_METHODS_PRICING_SERVICE_URL,
  requestTimeout: 60000,
}

const index = {
  production: prodConfig,
  development: devConfig,
}

export default index[process.env.NODE_ENV]
